"use client";

import { useEffect } from "react";

export default function LocaleError({ error, reset }: { error: Error & { digest?: string }; reset: () => void }) {
  useEffect(() => {
    console.error("[locale-error]", {
      message: error?.message,
      stack: error?.stack,
      digest: error?.digest,
    });
  }, [error]);

  return (
    <div
      style={{
        fontFamily: "system-ui, -apple-system, sans-serif",
        minHeight: "60vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: 32,
      }}
    >
      <div style={{ maxWidth: 640, textAlign: "center" }}>
        <h1 style={{ fontSize: 24, fontWeight: 700, marginBottom: 12 }}>Something went wrong</h1>
        <p style={{ opacity: 0.6, marginBottom: 24 }}>We hit an error while preparing this page.</p>
        {error?.message ? (
          <pre
            style={{
              background: "rgba(0,0,0,0.04)",
              padding: 16,
              borderRadius: 12,
              textAlign: "left",
              fontSize: 12,
              whiteSpace: "pre-wrap",
              wordBreak: "break-word",
              marginBottom: 24,
            }}
          >
            {error.message}
            {error.digest ? `\n\ndigest: ${error.digest}` : ""}
          </pre>
        ) : null}
        <button
          type="button"
          onClick={() => reset()}
          style={{
            background: "#0A0A0A",
            color: "#fff",
            border: 0,
            padding: "10px 20px",
            borderRadius: 9999,
            fontWeight: 600,
            cursor: "pointer",
          }}
        >
          Try again
        </button>
      </div>
    </div>
  );
}
